/**
 * BOTTOM GENERAL INITS
 * HEADER
 */

import { Header } from "./header";


export class HeaderInits {
    constructor() {
        this.initMap();
    }

    initMap() {
        if ($('header').length) {
            new Header();
        }
    }
}
